<template>
  <div class="business">
    <el-card class="top"
      ><span>{{ userName }}</span></el-card
    >
    <div class="center">
      <el-card class="card">
        <img src="../../../../assets/imgs/1.png" alt="" />
        <!-- <div id="qrcode"></div> -->
        <img src="https://qr.alipay.com/bax001204yns5nvp1plu00cf" alt="" />
        <div class="num">
          <span>{{ statisticalList.processedNum }}</span
          >户
        </div>
        <div>已处理终端用户</div>
      </el-card>
      <el-card class="card">
        <img src="../../../../assets/imgs/2.png" alt="" />
        <div class="num">
          <span>{{ statisticalList.unProcessedNum }}</span
          >户
        </div>
        <div>待处理终端用户</div>
      </el-card>
      <el-card class="card">
        <img src="../../../../assets/imgs/3.png" alt="" />
        <div class="num">
          <span>{{ statisticalList.rejectNum }}</span
          >户
        </div>
        <div>已驳回终端用户</div>
      </el-card>
    </div>
    <div class="bottom">
      <el-card class="box" v-for="item in dataList" :key="item.id">
        <div style="margin-bottom: 10px">工单号：{{ item.id }}</div>
        <el-table
          :data="[item]"
          style="width: 100%"
          border
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '7px 0' }"
          :header-cell-style="{
            background: '#e2eeeb',
            fontSize: '14px',
            color: '#000',
            fontWeight: 400,
            padding: '7px 0',
          }">
          <el-table-column prop="id" label="申请编号" width="180" />

          <el-table-column prop="realName" label="用户名称" />
          <el-table-column prop="realNum" label="用户编号" />
          <el-table-column prop="energy" label="是否装表">
            <template slot-scope="scope">
              {{ scope.row.energy == 1 ? "否" : "是" }}
            </template>
          </el-table-column>
          <el-table-column prop="capacity" label="合集容量" />
          <el-table-column prop="visitTime" label="上门时间" />

          <el-table-column prop="userAddr" label="用电地址" />
        </el-table>
        <div class="btns">
          <button class="second-btn" @click="handleBtn(item.id)">驳回</button>
          <el-button type="primary" @click="handleNextEv(item)"
            >业务受理</el-button
          >
          <!-- <el-button type="primary" @click="generatePaymentCodeEv"
            >支付码</el-button> -->
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  getBusinessApi,
  changeStatusApi,
  generatePaymentCodeApi,
} from "@/api/energyManagement.js";
export default {
  name: "",
  components: {},
  mounted() {
    this.getListEv();
    if (window.QRCode) {
    } else {
    }
  },
  data() {
    return {
      dataList: [{}],
      statisticalList: {
        processedNum: 0,
        unProcessedNum: 0,
        rejectNum: 0,
      },
      userName: sessionStorage.getItem("uname") || "",
    };
  },
  methods: {
    // 生成支付二维码
    generatePaymentCodeEv() {
      generatePaymentCodeApi().then((res) => {
        this.createQrcode(res.qrcode);
      });
    },
    createQrcode(url) {
      document.getElementById("qrcode").innerHTML = "";
      // 创建之前先清除旧的二维码
      var qrcode = new QRCode(document.getElementById("qrcode"), {
        text: url, //二维码内容
        width: 110, //设置宽高
        height: 110,
      });
      qrcode.makeCode();
      // document.getElementById("send").onclick = function () {
      //   qrcode.makeCode(document.getElementById("getval").value);
      // };
    },

    getListEv() {
      getBusinessApi().then((res) => {
        if (res.code == 200) {
          this.dataList = res.data.list;
          this.statisticalList = res.data.auditInfoDo;
        }
      });
    },
    handleBtn(id) {
      let params = {
        id: id,
        status: 2,
      };
      changeStatusApi(params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("成功");
          }
        })
        .catch(() => {});
      this.getListEv();
    },
    handleNextEv(data) {
      let query = data;

      this.$router.push({
        name: "BusinessAcceptance",
        params: query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business {
  max-width: 1872px;
  width: 100%;
  margin: 0 auto;

  .top {
    width: 100%;
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;

    span {
      color: #068667;
    }
  }

  .center {
    width: 100%;
    height: 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 0;

    .card {
      width: 30%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      ::v-deep .el-card__body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .num {
          > span {
            font-size: 25px;
            margin-right: 5px;
          }
        }
      }
    }
  }

  .bottom {
    .box {
      margin-bottom: 20px;

      ::v-deep .el-card__body {
        padding: 40px;
        box-sizing: border-box;

        .btns {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 20px;
          button {
            width: 120px;
          }
          .second-btn {
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            cursor: pointer;
            background: #8d0f06;
            border: 0;
            color: #fff;
            -webkit-appearance: none;
            text-align: center;
            box-sizing: border-box;
            outline: 0;
            margin: 0;
            transition: 0.1s;
            font-weight: 500;
            padding: 12px 20px;
            font-size: 14px;
            border-radius: 4px;
            margin: 0 10px;
            &:hover {
              background: #694d4a;
              // color: #8d0f06;
            }
          }
        }
      }
    }
  }
}
</style>
